export default "__VITE_ASSET__Bogf239i__"